export const ReferenceDataDomains = {
  EDUCATION_LEVEL: "EDUCATION_LEVEL",
  PERSONAL_DOCUMENT_TYPE: "PERSONAL_DOCUMENT_TYPE ",
  FOREIGN_IDENTIFIER_TYPE: "FOREIGN_IDENTIFIER_TYPE",
};
